
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppInput, AppButton } from '@/components';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_LOCALE } from '@/modules/locale/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_LOCALE,
    components: { AppTable, AppCard, AppInput, AppButton },
    setup() {
        const { query, list, total, fetchList, actions } = useLocale();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Language', key: 'language' },
                { type: TableColumnType.Text, label: 'Country', key: 'country' },
                { type: TableColumnType.Option, label: 'Mode', key: 'status', options: statusList },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-plus',
                        theme: 'primary',
                        tooltip: 'Add',
                        onclick: async () => await actions.add(row.id)
                    }),
                    canShow: (row: any) => row.status === 0,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye-slash',
                        theme: 'warning',
                        tooltip: 'Unpublish',
                        onclick: async () => await actions.unpublish(row.id)
                    }),
                    canShow: (row: any) => row.status === 2,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-check',
                        theme: 'success',
                        tooltip: 'Set default',
                        onclick: async () => await actions.setDefault(row.id)
                    }),
                    canShow: (row: any) => row.status === 2,
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'primary',
                        tooltip: 'Publish',
                        onclick: async () => await actions.publish(row.id)
                    }),
                    canShow: (row: any) => row.status === 1,
                    group: 3
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    }),
                    canShow: (row: any) => row.status === 1
                }
            ]
        };

        onMounted(fetchList);

        return { fetchList, list, total, query, table };
    }
});

const statusList = [
    { label: 'Default', background: 'success', value: 3 },
    { label: 'Published', background: 'primary', value: 2 },
    { label: 'Unpublished', background: 'info', value: 1 },
    { label: 'Unsupported', background: 'secondary', value: 0 }
];
